import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoaderService } from '../common/services/loader.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

   private readonly ignored401Urls = [
    'https://askmepythonapi-atcphegjdudxbsav.northeurope-01.azurewebsites.net/access-check-askmeanything',    
    'https://askmepythonapi-atcphegjdudxbsav.northeurope-01.azurewebsites.net/ark-access/'

  ];
   constructor(private router: Router, private _loaderService: LoaderService,) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

         const ignore401 = this.ignored401Urls.some(url =>
          req.url.startsWith(url)
        );

        if (error.status === 401 && !ignore401) {
          this._loaderService.hideLoader();
          this.router.navigate(['/unauthorized']);
        }

        return throwError(() => error);
      })
    );
  }
}
